/* eslint-disable global-require */
const dynamicReducers = {};

// `require` in every file except index.js from the current directory, then
// add their default export to module.exports based on their filename.
// eg dynamicMiddlewares["dynamicMiddleware"] = require("./dynamicMiddleware.js");
const req = require.context('.', true, /\.reducer\.js$/);
req.keys().forEach(fileName => {
  const exportName = fileName.replace('./', '').replace('.reducer.js', '');
  dynamicReducers[exportName] = req(fileName).default;
});

export { dynamicReducers };
